// StatusBar.js - Basic status bar implementation with menu toggle functionality

import React from 'react';
import './StatusBar.css';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import config from '../config'; // Import the centralized config

const logEventToServer = async (eventType, data) => {
    try {
        const response = await fetch(config.API_URL + '/api/frontend_log', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ event_type: eventType, data }),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
    } catch (error) {
        console.error('Error logging event to server:', error);
    }
};

function StatusBar({ isDarkTheme, handleThemeToggle }) {
    const handleLinkClick = (platform) => {
        logEventToServer('social_link_click', { platform });
    };

    return (
        <header className="status-bar">
            <h1 className="app-name">Samarth</h1>

            <div className="right-section">
                {/* Theme toggle button commented out - using light mode only 
                <button className="theme-toggle" onClick={handleThemeToggle} aria-label="Toggle dark mode">
                    {isDarkTheme ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="5"></circle>
                            <line x1="12" y1="1" x2="12" y2="3"></line>
                            <line x1="12" y1="21" x2="12" y2="23"></line>
                            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                            <line x1="1" y1="12" x2="3" y2="12"></line>
                            <line x1="21" y1="12" x2="23" y2="12"></line>
                            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                        </svg>
                    )}
                </button>
                */}
                <div className="social-icons">
                    <a
                        href="https://github.com/samarth-ar10"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleLinkClick('GitHub')}
                    >
                        <FaGithub size={24} />
                    </a>
                    <a
                        href="https://www.linkedin.com/in/samarth-nln/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleLinkClick('LinkedIn')}
                    >
                        <FaLinkedin size={24} />
                    </a>
                </div>
            </div>
        </header>
    );
}

export default StatusBar;